import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
  height: 100%;
`;

export const ContainerBody = styled.div`
  display: flex;
  height: 100%;
  padding: 0 4rem;
  @media (max-width: 1025px) {
    padding: 0 1rem;
  }
`;

export const Content = styled.main`
  margin-top: 1rem;
  width: 100%;
  display: flex;
  flex-direction: column;

  @media (max-width: 769px) {
    overflow-x: hidden;
  }
`;

export const Button = styled.button`
  margin-left: 10rem;
  background: #fff7df;
  border: 0;
  border-radius: 2rem;

  &:hover {
    filter: brightness(100%);
  }

  @media (max-width: 769px) {
    margin-left: 6rem;
  }
`;

export const PainelDiv = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-end;

  div {
    margin-left: 50px;
  }
  @media (max-width: 769px) {
    div {
      margin-left: 0;
    }
  }
`;

export const ContentInfo = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  > p {
    font-size: 1.1rem;
    span {
      font-weight: 700;
      line-height: 1.3rem;
    }
  }
`;

export const SubTitleDiv = styled.div`
  display: flex;
  align-items: center;
`;

export const TimerDiv = styled.div`
  padding-left: 1rem;
  font-weight: 600;
  display: flex;
  align-items: center;
  justify-content: space-between;

  width: 100%;
`;

export const Timer = styled.div`
  margin-right: 1rem;
  display: flex;
  align-items: center;

  > p {
    margin-right: 10px;
  }
`;

export const MonitoramentoContainer = styled.div`
  width: 100%;
  background-color: #fff7df;
  margin: -0.7rem 0;
  padding: 10px;
  border-radius: 0px 15px 15px 15px;

  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 8rem;

  .mapa {
    margin-left: 13rem;
  }
  @media (max-width: 1367px) {
    .mapa {
      margin-left: 1rem;
    }
  }
  @media (max-width: 1025px) {
    .mapa {
      width: 29rem;
      margin-left: -3rem;
    }
  }
  @media (max-width: 769px) {
    display: block;
    padding-bottom: 1rem;
    .mapa {
      margin-left: 6rem;
      margin-bottom: 2rem;
    }
  }
  @media (max-width: 600px) {
    .mapa {
      margin-left: 1rem;
    }
  }
  @media (max-width: 415px) {
    .mapa {
      margin-left: -4.5rem;
    }
  }
`;

export const TotalNegociadoContainer = styled.div`
  width: 500px;
  height: 100%;
  background-color: #ffff;
  border-radius: 15px;

  display: flex;
  flex-direction: column;

  @media (max-width: 1025px) {
    margin-left: -2.5rem;
    width: 90%;
  }
  @media (max-width: 769px) {
    margin: auto;
    height: auto;
    padding-bottom: 2rem;
  }
`;

export const TotalNegociadoInfo = styled.div`
  margin: 0.8rem 1.6rem;
  display: flex;
  align-items: center;
  justify-content: space-between;

  h2 {
    color: var(--color-primary);
  }

  .total {
    width: 234px;
    height: 44px;
    background-color: #fff7df;
    border-radius: 5px;

    display: flex;
    justify-content: center;
    align-items: center;

    p {
      font-weight: 500;
      font-size: 1.2rem;
    }
  }
`;

export const FiltroTotalNegociado = styled.div`
  margin: 0 1.6rem;
  display: flex;
  align-items: center;
  justify-content: center;
  a {
    img {
      margin-top: 2px;
      width: 40px;
      height: 40px;
    }
  }
`;

export const OpcaoFiltro = styled.form`
  width: 440px;
  height: 40px;
  border: 2px solid #ccc;
  border-radius: 5px;

  font-weight: 700;
  display: flex;
  align-items: center;
  justify-content: space-evenly;
`;

export const InputFiltro = styled.div`
  display: flex;
  align-items: center;

  input {
    /* Add if not using autoprefixer */
    /* -webkit-appearance: none; */
    /* Remove most all native input styles */
    /* appearance: none; */
    /* For iOS < 15 */
    /* Not removed via appearance */

    font: inherit;
    color: var(--color-primary);
    width: 1.15rem;
    height: 1.15rem;
    border: 0.15rem solid var(--percentage);
    border-radius: 50%;
    transform: translateY(-0.085rem);

    display: grid;
    place-content: center;

    &::before {
      content: '';
      width: 0.63rem;
      height: 0.63rem;
      border-radius: 50%;
      transform: scale(0);
      transition: 120ms transform ease-in-out;
      box-shadow: inset 1rem 1rem var(--percentage);
      background-color: var(--percentage);
    }

    &:checked::before {
      transform: scale(1);
      background-color: var(--color-primary);
    }
  }

  label {
    margin-left: 8px;
    font-family: 'Rubik', sans-serif;
    font-weight: 400;
    font-size: 0.9rem;
    line-height: 1rem;
  }
`;

export const Ranking = styled.div`
  background-color: #fff7df;
  margin: 0.7rem 1.6rem 0;
  width: 455px;
  height: 33px;
  border-radius: 0px 5px 5px 0px;

  display: flex;
  align-items: center;

  > P {
    margin-left: 1rem;
    font-size: 1.2rem;
  }

  @media (max-width: 1025px) {
    width: calc(100% - 3rem);
  }
`;

export const ClassificacaoRanking = styled.div`
  background-color: var(--color-primary);
  width: 33px;
  height: 33px;
  border-radius: 5px 0px 0px 5px;

  display: flex;
  align-items: center;
  justify-content: center;

  P {
    margin-left: 4px;
    font-size: 1.4rem;
    font-weight: 900;
    text-transform: capitalize;
    color: #fff;
  }
`;

export const Footer = styled.footer`
  width: 100%;
  height: 60px;
  position: relative;
  bottom: 0;
  background: var(--background);
  box-shadow: 0px -4px 4px rgba(0, 0, 0, 0.25);
`;
